import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SupportedLanguage } from '../services/languageService';

interface SettingsState {
  // Language settings
  language: SupportedLanguage;
  setLanguage: (language: SupportedLanguage) => void;

  // Notification settings
  pushNotificationsEnabled: boolean;
  setPushNotificationsEnabled: (enabled: boolean) => void;
  featureNotificationsEnabled: boolean;
  setFeatureNotificationsEnabled: (enabled: boolean) => void;

  // Privacy settings
  sharePlaybackHistory: boolean;
  setSharePlaybackHistory: (share: boolean) => void;

  // Playback settings
  audioQuality: '320' | '160' | '96' | 'auto';
  setAudioQuality: (quality: '320' | '160' | '96' | 'auto') => void;
  crossfadeEnabled: boolean;
  setCrossfadeEnabled: (enabled: boolean) => void;
  volume: number;
  setVolume: (volume: number) => void;
  isMuted: boolean;
  setIsMuted: (muted: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      // Language
      language: 'en',
      setLanguage: (language) => set({ language }),

      // Notifications
      pushNotificationsEnabled: true,
      setPushNotificationsEnabled: (enabled) => set({ pushNotificationsEnabled: enabled }),
      featureNotificationsEnabled: true,
      setFeatureNotificationsEnabled: (enabled) => set({ featureNotificationsEnabled: enabled }),

      // Privacy
      sharePlaybackHistory: false,
      setSharePlaybackHistory: (share) => set({ sharePlaybackHistory: share }),

      // Playback
      audioQuality: 'auto',
      setAudioQuality: (quality) => set({ audioQuality: quality }),
      crossfadeEnabled: true,
      setCrossfadeEnabled: (enabled) => set({ crossfadeEnabled: enabled }),
      volume: 0.8,
      setVolume: (volume) => set({ volume: Math.max(0, Math.min(1, volume)) }),
      isMuted: false,
      setIsMuted: (muted) => set({ isMuted: muted }),
    }),
    {
      name: 'settings-storage',
      version: 1,
    }
  )
); 